import type { GroupValueSet } from '~/common/model/admin';

import type { TransformGroups } from './_group.type';

/**
 * Prepare groups.
 *
 * @param {TransformGroups} groups Transform Groups.
 *
 * @returns {GroupValueSet[]} Groups.
 */
export function prepareGroups(groups: TransformGroups): GroupValueSet[] {
  return Object.entries(groups).map(([id, group]) => ({
    ...group,
    id,
  }));
}
